






































































































































































import {Vue, Component, PropSync, Watch} from 'vue-property-decorator';
import proxySettingsForm from "@/pages/Pages/Push/proxySettingsForm.vue";
import {SelectWings, InputWings} from "wings-ui-components";
import {ApnsType} from "@/store/push/application/types";

@Component({components: {SelectWings, proxySettingsForm, InputWings}})
export default class ApnsSettings extends Vue {
  @PropSync('apnsOptions') apns!: ApnsType;
  @PropSync('filesOptions') files!: { file: File, type: string }[];
  private serverTypeList: string[] = ['PRODUCTION', 'DEVELOPMENT', 'SIMULATOR']
  private isProxySettings: boolean = false;

  onFilePicked(file: File, type?: string | null) {
    if (!type) return;
    this.files?.push({file: file, type: type});
    if (type === 'p8') {
      this.apns.key_id = null;
    } else {
      this.apns.passphrase = null;
    }
  }

  created() {
    if(this.apns.proxy_settings_name) this.isProxySettings = true;
  }

  @Watch('isProxySettings')
  onChangeProxy(newValue: boolean) {
    if (!newValue) this.apns.proxy_settings_id = undefined;
  }
}
